import { ApprovalView } from "@pjs/feedback";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";
angularAMD.component("approvalView", react2angular(ApprovalView, ["feedback", "labelText", "statusNotice"]));
